import styled from "styled-components";

import { colorsPalettes, setElevation } from "@similarweb/styles";
import { Stack } from "@similarweb/ui-components/foundations";

import { NAVIGATION_SIDEBAR_WIDTH } from "app/pages/activation/constants/styles";

const { blue, bluegrey } = colorsPalettes;

export const Container = styled(Stack)`
    align-items: center;

    padding: 40px 44px;
    height: 100vh;
    overflow-y: auto;
    width: calc(100% - ${NAVIGATION_SIDEBAR_WIDTH});
    margin-left: ${NAVIGATION_SIDEBAR_WIDTH}px;
    background: linear-gradient(180deg, ${blue[100]} 0%, ${bluegrey[100]} 32.08%);
`;

export const ContentContainer = styled(Stack)`
    gap: 32px;
    width: 100%;
    max-width: 1366px;
`;

export const DataContainer = styled(Stack)`
    gap: 32px;
    padding: 16px;
    width: 100%;

    background: ${blue[100]};
    border-radius: 6px;

    ${setElevation("Z1")};
`;
